export const recategorizePrompt = {
  contextPrefix: `
The following is a list of transactions the user explicitly selected for recategorization, along with the full
list of categories available in their account. Use ONLY this data - do not look up or invent information about
the merchant or category.
`,
  prompt: `
You are proposing a better category for each transaction in a list, based on its payee, date, amount, and current
category.

Rules:
- Only propose a category that is a confident, meaningfully better fit than the transaction's current category.
- If the current category already looks correct, or you are not confident a different category is clearly better,
  omit that transaction entirely - do not force a change.
- It is fine to return an empty proposals array if none of the transactions need a change.
- Only propose a category from the provided allowed categories list, using its exact id from that list.
- Never propose changes to payee, amount, date, memo, or tags. This action only proposes category changes.

Return a JSON object with a single "proposals" key: an array of objects, each with:
- "transactionId": the exact transaction ID from the input, unchanged
- "proposedCategoryId": the exact id of the proposed category from the allowed list
- "confidence": a number from 0 to 1 indicating how confident you are the proposed category is correct
- "rationale": one short sentence explaining the change
`,
  schema: {
    name: 'RecategorizeProposalResponse',
    schema: {
      type: 'object',
      additionalProperties: false,
      strict: true,
      properties: {
        proposals: {
          type: 'array',
          items: {
            type: 'object',
            additionalProperties: false,
            properties: {
              transactionId: { type: 'string' },
              proposedCategoryId: { type: 'string' },
              confidence: { type: 'number' },
              rationale: { type: 'string' },
            },
            required: ['transactionId', 'proposedCategoryId', 'confidence', 'rationale'],
          },
        },
      },
      required: ['proposals'],
    },
  },
};
